import { INSERT_ADMINISTRATIVE_PANEL_DATA, GET_QUEUES } from './mutation-types'
import painelAdministrativoHttpService from '../_services/painelAdministrativoHttpService'

export default {
  obtemDadosPainelAdministrativo: async ({ commit }, form) => {
    try {
      const response = await painelAdministrativoHttpService.buscarDadosPainel(form)
      commit(INSERT_ADMINISTRATIVE_PANEL_DATA, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  listarFilas: async ({ commit }) => {
    try {
      const response = await painelAdministrativoHttpService.getFilas()
      commit(GET_QUEUES, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
}
